<dx-popup
    id="popup"
    [(visible)]="formVisible"
    [width]="isPhone || isPhoneLandscape ? '90vw' : 580"
    [height]="'auto'"
    [maxHeight]="'90vh'"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [closeOnOutsideClick]="false"
    (onHidden)="close()"
>
    <dxi-toolbar-item location="before">
        <h4 style="margin: 5px 0">User Form</h4>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Save" [disabled]="isLoading || isBackgroundLoading" (click)="submit($event)"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" id="toast">
        <dx-scroll-view>
            <form (submit)="submit($event)">
                <dx-form
                    #form
                    [(formData)]="user"
                    [readOnly]="false"
                    validationGroup="userData">
                    <dxi-item #tab itemType="tabbed" [tabPanelOptions]="{ deferRendering: false, onTitleClick: onTabSelectionChange, onContentReady: onContentReady,
                        selectedIndex: tabIndex }">
                        <dxi-tab title="Personal Data">
                            <dxi-item dataField="email" [editorOptions]="{onContentReady: ready}">
                                <dxo-label text="Email"></dxo-label>
                                <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                                <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="lastName">
                                <dxo-label text="Last Name"></dxo-label>
                                <dxi-validation-rule type="required" message="Last Name is required"></dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="firstName">
                                <dxo-label text="First Name"></dxo-label>
                                <dxi-validation-rule type="required" message="First Name is invalid"></dxi-validation-rule>
                            </dxi-item>
                            <dxi-item
                                dataField="role"
                                editorType="dxSelectBox"
                                [editorOptions]="{
                                    dataSource: roles | async,
                                    displayExpr: 'name',
                                    valueExpr: 'name',
                                    placeholder: 'Select a role',
                                    disabled: user?.id === authenticatedUser.id,
                                    onValueChanged: roleChanged
                                }">
                                <dxo-label text="Role"></dxo-label>
                                <dxi-validation-rule type="required" message="Role is invalid"></dxi-validation-rule>
                            </dxi-item>
                        </dxi-tab>
                        <dxi-tab *ngIf="activeTab() === 'client'" title="Clients">
                            <div *dxTemplate>
                                <app-glass
                                    [arr]="clients.value.store()"
                                    [keyExpr]="'id'"
                                    [displayExpr]="'name'"
                                    [mode]="'multiple'"
                                    [label]="'Clients'"
                                    [disabled]="user?.id === authenticatedUser.id"
                                    [placeholder]="'Select a client...'"
                                    [dropDownColumns]="clientsGlassDropDownColumns"
                                    [columns]="clientsGlassGridColumns"
                                    [selectedItemsKeys]="user?.data?.clients"
                                    [selectedItemsRowsOnlyEdit]="clientsOnlyForEdit"
                                    [disableInEdit]="authenticatedRole === 'Client Admin' || authenticatedRole === 'Client Basic'"
                                    [selectedItemNoAccess]="authenticatedUser ? authenticatedUser.data ? authenticatedUser.data.clients : [] : []"
                                    (changes)="clientsGlassChanged($event)"
                                ></app-glass>
                            </div>
                        </dxi-tab>
                        <dxi-tab *ngIf="activeTab() === 'physician'" title="Physicians">
                            <div *dxTemplate>
                                <app-glass
                                    [arr]="physicians.value.store()"
                                    [keyExpr]="'id'"
                                    [displayExpr]="physicianDisplayExp"
                                    [mode]="'multiple'"
                                    [label]="'Physicians'"
                                    [disabled]="user?.id === authenticatedUser.id"
                                    [placeholder]="'Select a physician...'"
                                    [dropDownColumns]="physiciansGlassDropDownColumns"
                                    [columns]="physiciansGlassGridColumns"
                                    [selectedItemsKeys]="user?.data?.physicians"
                                    [selectedItemsRowsOnlyEdit]="physiciansOnlyForEdit"
                                    (changes)="physiciansGlassChanged($event)"
                                ></app-glass>
                            </div>
                        </dxi-tab>
                        <dxi-tab *ngIf="activeTab() === 'patient'" title="Patients">
                            <div *dxTemplate>
                                <app-glass
                                    [arr]="patients.value.store()"
                                    [keyExpr]="'id'"
                                    [displayExpr]="patientDisplayExp"
                                    [label]="'Patients'"
                                    [mode]="'multiple'"
                                    [placeholder]="'Select a patient...'"
                                    [disabled]="user?.id === authenticatedUser.id"
                                    [dropDownColumns]="patientsGlassDropDownColumns"
                                    [columns]="patientsGlassGridColumns"
                                    [selectedItemsKeys]="user?.data?.patients"
                                    [selectedItemsRowsOnlyEdit]="patientsOnlyForEdit"
                                    (changes)="patientsGlassChanged($event)"
                                ></app-glass>
                            </div>
                        </dxi-tab>
                    </dxi-item>
                </dx-form>
            </form>
            <dx-load-panel [visible]="isLoading" [container]="'#popup'"></dx-load-panel>
        </dx-scroll-view>
    </div>
</dx-popup>
